/**
 * TODO:  Reorganize the order of computed items, Alphabetically?  Grouped by use?
 */
import moment from 'moment'

export default {
  computed: {
    hasAddAccess () {
      return this.$ftAccess.manageReservations
    },
    clubUsesEvents () {
      return this.$ftCS.DINING_USES_EVENTS
    },
    clubUsesMealPeriods () {
      return this.$ftCS.DINING_USES_RESERVATIONS
    },
    reservationListPageBarButtons () {
      return [
        {icon: 'mdi-refresh', action: this.refreshList, disabled: this.isDataLoading}
      ]
    },
    headers () {
      const showColumns = (this.searchFilter || {}).columns || {}
      return [
        this.headerSlot('#', 'id'),
        this.headerDateTime('Date/Time', 'dateTime'),
        this.headerSlot('Reservees', 'details'),
        this.headerText('Location', 'locationName'),
        this.headerSlot('Event / Meal Period', 'eventName'), // Also displays mealPeriodName
        ...showColumns.confirmationStatus ? [this.headerText('Conf. Status', 'confirmationStatus')] : [],
        this.headerSlot('Covers', 'covers', false, {'ft-thin-cell': true}),
        this.headerSlot('Tables', 'tableAssignments'),
        ...this.itemsHaveIssue || showColumns.issues ? [this.headerText('Issues', 'issues')] : [],
        ...showColumns.created ? [this.headerDateTime('Created', 'created')] : []
      ]
    },
    reservationListContextMenu () {
      const menuItems = [
        {hide: this.showItem}, // divider
        {
          title: 'Reset Listing Filter',
          icon: 'mdi-filter-remove',
          action: this.clearSearchFilter,
          hide: this.showItem
        }
      ]
      return this.defaultContextMenu.concat(menuItems)
    },
    eventByDateMap () {
      return this.events.reduce((o, e) => {
        const bStart = moment(e.startDateTime).format('YYYY-MM-DD')
        const bEnd = moment(e.endDateTime).format('YYYY-MM-DD')
        var ary = o[bStart]
        if (!ary) {
          ary = []
          o[bStart] = ary
        }
        ary.push(e)
        if (bStart !== bEnd) {
          ary = o[bEnd]
          if (!ary) {
            ary = []
            o[bEnd] = ary
          }
          ary.push(e)
        }
        return o
      }, {})
    },
    blockerByDateMap () {
      return this.blockers.reduce((o, b) => {
        const bStart = moment(b.startDate)
        const bEnd = moment(b.endDate)
        for (var m = bStart; m.isSameOrBefore(bEnd); m.add(1, 'days')) {
          let d = m.format('YYYY-MM-DD')
          var ary = o[d]
          if (!ary) {
            ary = []
            o[d] = ary
          }
          ary.push(b)
        }
        return o
      }, {})
    },
    minFilterDate () {
      return this.minFilterDateTime ? moment(this.minFilterDateTime).format('YYYY-MM-DD') : null
      /*
      return this.selectedEventsFilter.reduce((min, event) => {
        return event.date < min || !min ? event.date : min
      }, minDateDefault)
      */
    },
    maxFilterDate () {
      return this.maxFilterDateTime ? moment(this.maxFilterDateTime).format('YYYY-MM-DD') : null
      /*
      return this.selectedEventsFilter.reduce((max, event) => {
        return event.date > max || !max ? event.date : max
      }, maxDateDefault) || this.$ftAPI().clubMoment().add(5, 'years').format('YYYY-MM-DD')
      */
    },
    selectedEventsFilter () {
      return this.events.filter(e => e.name === this.searchFilter.eventName)
    },
    selectedEventDates () {
      const minDate = this.minFilterDate
      const maxDate = this.maxFilterDate
      const result = this.selectedEventsFilter.map(e => {
        const edate = moment(e.date).format('YYYY-MM-DD')
        return {text: edate, value: edate}
      }).filter(opt => (!minDate || opt.value >= minDate) && (!maxDate || opt.value <= maxDate))
      if (result.length && !result.find(opt => opt.value === this.searchFilter.date)) {
        this.searchFilter.date = null
      }
      return result
    },
    selectedEventFilter () {
      return this.selectedEventsFilter.length === 1 ? this.selectedEventsFilter[0] : this.selectedEventsFilter
        .find(e => e.date === this.searchFilter.date)
    },
    selectedEventsCostsFilter () {
      return this.selectedEventsFilter.reduce((costs, event) => {
        costs.push(...event.costs.filter(c => {
          c.eventName = event.name
          c.eventStartDateTime = event.startDateTime
          return true
        }))
        return costs
      }, [])
    },
    uniqueSelectedEventsCostsFilter () {
      const found = {}
      return this.selectedEventsCostsFilter.filter(c => {
        const key = c.name
        if (found[key]) return false
        found[key] = true
        return true
      })
    },
    selectedMealPeriodIds () {
      console.log('selectedMealPeriodIds', this.searchFilter.mealPeriodIds)
      return (this.searchFilter.mealPeriodIds || []).reduce((a, mp) => {
        a[mp] = true
        return a
      }, {})
    },
    selectedMealPeriodsFilter () {
      const mpIds = this.selectedMealPeriodIds
      return this.mealPeriods.filter(mp => mpIds[mp.id])
    },
    distinctEventNames () {
      const names = {}
      const minDate = this.minFilterDate
      const maxDate = this.maxFilterDate
      return this.events.filter(e => {
        if (!names[e.name] && (!minDate || e.date >= minDate) && (!maxDate || e.date <= maxDate)) {
          names[e.name] = e
          return true
        }
        return false
      })
    },
    eventMap () {
      return this.events.reduce((result, event) => {
        result[event.id] = event
        return result
      }, {})
    },
    guestTypeMap () {
      return this.guestTypes.reduce((result, guestType) => {
        result[guestType.id] = guestType
        return result
      }, {})
    },
    selectedDateIsTooOld () {
      if (this.itemData.date) {
        const selectedDate = moment(this.itemData.date + ' 23:59:59')
        return selectedDate.isBefore(this.minimumDiningDate)
      }
      return false
    },
    selectedDateIsInPast () {
      if (this.itemData.date) {
        const now = this.$ftAPI().clubMoment()
        const selectedDate = moment(this.itemData.date + ' 23:59:59')
        return selectedDate.isBefore(now)
      }
      return false
    },
    selectedDateIsInPastMessage () {
      if (!this.selectedDateIsInPast) return
      return this.forEvent ? 'Event is in the past' : 'Date is in the past'
    },
    availLocationsMap () {
      return this.availLocations.reduce((result, location) => {
        result[location.id] = location
        return result
      }, {})
    },
    availLocations () {
      const eventToLocationMap = this.eventToLocationMap
      if (this.forEvent) {
        // For event res
        return this.locations
          // Only return locations applicable to this event
          .filter(location => !!eventToLocationMap[location.id])
          // Sorted by the applicable location's binding order
          .sort((a, b) => {
            const ae2l = eventToLocationMap[a.id]
            const be2l = eventToLocationMap[b.id]
            return ae2l.pos < be2l.pos ? -1 : ae2l.pos > be2l.pos ? 1 : 0
          })
      } else {
        // For meal period res
        // Float enabled locations to the top
        return this.locations.filter(location => !location.disabled).concat(
          this.locations.filter(location => location.disabled)
        )
      }
    },
    modGuestTypes () {
      return [{id: null, name: 'Member', selectType: 'member'}].concat(this.guestTypes.filter(g => !g.useGuestdb))
    },
    originatedBySelectList () {
      return [
        {
          field: 'origMemberId',
          name: 'Member'
        },
        {
          field: 'origStaffId',
          name: 'Staff'
        }
      ]
    },
    // Make a table / record for these?
    listingSortOrder () {
      return [
        {
          id: null,
          name: 'Date/Time, Oldest First',
          order: ['dateTime:ASC']
        },
        {
          id: 1,
          name: 'Date/Time, Newest First',
          order: ['dateTime:DESC']
        },
        {
          id: 3,
          name: 'Created, Oldest First',
          order: ['created:ASC']
        },
        {
          id: 2,
          name: 'Created, Newest First',
          order: ['created:DESC']
        },
        {
          id: 4,
          name: 'Location',
          order: ['locationName:ASC', 'dateTime:DESC']
        },
        {
          id: 5,
          name: 'Event',
          order: ['eventName:ASC', 'dateTime:DESC']
        },
        {
          id: 6,
          name: 'Meal Period',
          order: ['mealPeriodName:ASC', 'dateTime:DESC']
        }
      ]
    },
    occasionsMap () {
      return this.occasions.reduce((result, item) => {
        result[item.id] = item
        return result
      }, {})
    },
    listingSortOrderMap () {
      return this.listingSortOrder.reduce((result, item) => {
        result[item.id] = item
        return result
      }, {})
    }
  }
}
